document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.gp-menu-toggle');
  const menu = document.querySelector('.gp-nav');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
    });
  }

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealItems = document.querySelectorAll('[data-reveal]');
  if (!reduceMotion && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  const bookStage = document.querySelector('[data-book-stage]');
  if (bookStage && !reduceMotion && window.matchMedia('(pointer: fine)').matches) {
    bookStage.addEventListener('pointermove', (event) => {
      const rect = bookStage.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width - 0.5) * 8;
      const y = ((event.clientY - rect.top) / rect.height - 0.5) * -6;
      bookStage.style.setProperty('--tilt-x', `${y}deg`);
      bookStage.style.setProperty('--tilt-y', `${x}deg`);
    });
    bookStage.addEventListener('pointerleave', () => {
      bookStage.style.setProperty('--tilt-x', '0deg');
      bookStage.style.setProperty('--tilt-y', '0deg');
    });
  }

  document.querySelectorAll('[data-quiz-section]').forEach(initQuiz);
  const sort = document.querySelector('[data-sort-by]');
  if (sort) {
    const current = new URLSearchParams(window.location.search).get('sort_by');
    if (current) sort.value = current;
    sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      window.location.assign(url.toString());
    });
  }
});

function initQuiz(section) {
  const dataNode = section.querySelector('[data-quiz-json]');
  const game = section.querySelector('[data-quiz-game]');
  if (!dataNode || !game) return;
  let parsed;
  try { parsed = JSON.parse(dataNode.textContent); } catch (_) { return; }
  const questions = Array.isArray(parsed) ? parsed : parsed.questions;
  if (!Array.isArray(questions) || !questions.length) return;
  let index = 0;
  let score = 0;

  const renderQuestion = () => {
    const item = questions[index];
    const answers = item.answers || item.choices || [];
    game.innerHTML = `<div class="gp-quiz__progress"><span style="width:${((index + 1) / questions.length) * 100}%"></span></div><small>Question ${index + 1} sur ${questions.length}</small><h3>${escapeHtml(item.question || '')}</h3><div class="gp-quiz__answers"></div><p class="gp-quiz__feedback" data-feedback></p>`;
    const answerList = game.querySelector('.gp-quiz__answers');
    answers.forEach((answer, answerIndex) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = typeof answer === 'string' ? answer : answer.label;
      button.addEventListener('click', () => chooseAnswer(answerIndex, item, button));
      answerList.appendChild(button);
    });
  };

  const chooseAnswer = (answerIndex, item, button) => {
    const correctIndex = Number(item.correct ?? item.correctIndex ?? 0);
    const buttons = [...game.querySelectorAll('.gp-quiz__answers button')];
    buttons.forEach((choice, choiceIndex) => {
      choice.disabled = true;
      if (choiceIndex === correctIndex) choice.classList.add('is-correct');
    });
    const feedback = game.querySelector('[data-feedback]');
    if (answerIndex === correctIndex) {
      score += 1;
      button.classList.add('is-correct');
      feedback.textContent = item.success || 'Bravo, tu as trouvé !';
    } else {
      button.classList.add('is-wrong');
      feedback.textContent = item.explanation || 'Presque ! Regarde la bonne réponse et continue.';
    }
    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'gp-button gp-button--night';
    next.textContent = index + 1 < questions.length ? 'Question suivante →' : 'Voir mon résultat →';
    next.addEventListener('click', () => {
      index += 1;
      if (index < questions.length) renderQuestion(); else renderResult();
    });
    feedback.after(next);
  };

  const renderResult = () => {
    const message = score === questions.length ? 'Mission accomplie, super explorateur !' : 'Belle exploration ! Chaque réponse aide à grandir.';
    game.innerHTML = `<div class="gp-quiz__result"><span>✦</span><h3>${message}</h3><p>Tu as trouvé ${score} bonne${score > 1 ? 's' : ''} réponse${score > 1 ? 's' : ''} sur ${questions.length}.</p><button type="button" class="gp-button gp-button--coral" data-restart>Recommencer</button></div>`;
    game.querySelector('[data-restart]').addEventListener('click', () => { index = 0; score = 0; renderQuestion(); });
  };

  game.querySelector('[data-quiz-start]')?.addEventListener('click', renderQuestion);
}

function escapeHtml(value) {
  const node = document.createElement('span');
  node.textContent = String(value);
  return node.innerHTML;
}


function initEbookCatalogue(root) {
  const cards = [...root.querySelectorAll('[data-ebook-card]')];
  const filters = [...root.querySelectorAll('[data-filter]')];
  const search = root.querySelector('[data-catalogue-search]');
  const count = root.querySelector('[data-catalogue-count]');
  const empty = root.querySelector('[data-catalogue-empty]');
  const dialog = root.querySelector('[data-ebook-dialog]');
  const productsNode = root.querySelector('[data-products-json]');
  let products = [];
  try { products = JSON.parse(productsNode?.textContent || '[]'); } catch (_) {}
  const state = { collection: 'all', age: 'all', query: '' };

  const setFilter = (group, value) => {
    state[group] = value;
    root.querySelectorAll(`[data-filter-group="${group}"]`).forEach((item) => {
      item.classList.toggle('is-active', item.dataset.filter === value);
    });
  };

  const apply = () => {
    let visible = 0;
    cards.forEach((card) => {
      const matchesCollection = state.collection === 'all' || card.dataset.collection === state.collection;
      const matchesAge = state.age === 'all' || card.dataset.age === state.age;
      const matchesQuery = !state.query || card.dataset.title.includes(state.query);
      const show = matchesCollection && matchesAge && matchesQuery;
      card.hidden = !show;
      if (show) visible += 1;
    });
    if (count) count.textContent = String(visible);
    empty?.classList.toggle('is-visible', visible === 0);
  };

  filters.forEach((button) => button.addEventListener('click', () => {
    const group = button.dataset.filterGroup;
    setFilter(group, button.dataset.filter);
    apply();
  }));

  document.querySelectorAll('[data-catalogue-target]').forEach((trigger) => trigger.addEventListener('click', (event) => {
    event.preventDefault();
    if (trigger.dataset.ageFilter) {
      setFilter('collection', 'all');
      setFilter('age', trigger.dataset.ageFilter);
    }
    if (trigger.dataset.collectionFilter) {
      setFilter('age', 'all');
      setFilter('collection', trigger.dataset.collectionFilter);
    }
    if (search) {
      search.value = '';
      state.query = '';
    }
    apply();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (window.history?.replaceState) window.history.replaceState(null, '', '#ebooks');
  }));
  search?.addEventListener('input', () => { state.query = search.value.trim().toLocaleLowerCase('fr'); apply(); });

  const openDialog = (index) => {
    if (!dialog || !products[index]) return;
    const item = products[index];
    dialog.querySelector('[data-dialog-cover]').src = item.cover;
    dialog.querySelector('[data-dialog-cover]').alt = `Couverture de ${item.title}`;
    dialog.querySelector('[data-dialog-collection]').textContent = item.collection;
    dialog.querySelector('[data-dialog-title]').textContent = item.title;
    dialog.querySelector('[data-dialog-description]').textContent = item.description;
    dialog.querySelector('[data-dialog-age]').textContent = item.age;
    dialog.querySelector('[data-dialog-pages]').textContent = `${item.pages} pages`;
    dialog.querySelector('[data-dialog-quiz]').textContent = 'Quiz inclus';
    dialog.querySelector('[data-dialog-price]').textContent = item.price;
    const productLink = dialog.querySelector('[data-dialog-product-link]');
    if (productLink) {
      const handle = item.title
        .toLocaleLowerCase('fr')
        .replace(/œ/g, 'oe')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
      productLink.href = `/products/${handle}`;
      productLink.setAttribute('aria-label', `Voir la fiche produit de ${item.title}`);
    }
    if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
  };
  root.querySelectorAll('[data-ebook-open]').forEach((button) => button.addEventListener('click', () => openDialog(Number(button.dataset.ebookOpen))));
  dialog?.querySelector('[data-dialog-close]')?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  dialog?.querySelector('[data-dialog-preview-close]')?.addEventListener('click', () => dialog.close());
  apply();
}
document.addEventListener('DOMContentLoaded', () => document.querySelectorAll('[data-ebook-catalogue]').forEach(initEbookCatalogue));
